/**
 * Dependencies
 */
import Vue from 'vue';

/**
 * Components
 */
import CommitteesList from '@/committees/CommitteesList';

/**
 * Vue instance
 */

export default (() => {
    // Check for DOM element
    if (!document.querySelector('#committees')) return false;

    return new Vue({
        el: '#committees',

        components: {
            'committees-list': CommitteesList,
        },

        data: {

        },
    })
})();